enum NavLink {
  LOGIN = "/Login",
  SIGNUP = "/Signup",
  ROUTINE = "/Routine"
}

export default NavLink;
